import React, { useState, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import EditorToolbar, { modules, formats } from "./EditorToolbar";
import "react-quill/dist/quill.snow.css";
import { Button } from "reactstrap";
import { Modules } from "../../../constants/Module";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";

export const TextEditor = (props) => {
    const [state, setState] = useState(props?.content ?? '');
    const [editor, setEditor] = useState();
    const [isEditing, setIsEditing] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    const isCommentModule = props.module === Modules.COMMENT

    const handleChange = value => {
        setState(value);
    };
    const handleFocus = (e) => {
        if (!props?.disabled) {
            setIsEditing(true);
            setIsAlert(false) 
        }
    }

    useEffect(() => {
        if (props.isEmpty) {
            setState('')
        }
    }, [props.isEmpty])

    const onToolBar = ()=>{
	return  new Promise((resolve)=> {
        document.querySelector('.ql-toolbar').addEventListener("click", (e) => {
            setIsAlert(false)
			resolve(true);
		})
		setTimeout(()=>{
			resolve(false);
		},50);
        });
    }

    const handleQuillBlur = (range, source, editor) => {
        onToolBar()
        if (source !== 'silent') {
            setIsAlert(true) 
        } else {
            setIsAlert(false) 
        }
    }

    return (
        <>
            {isEditing ?
                <div className="text-editor">
                    <EditorToolbar className="ql-toolbar" toolbarId={props?.toolbarId} />
                    {isAlert && (   
                    <SweetAlert
                        title={props.t("Are you sure want to discard this change") + '?'}
                        warning
                        showCancel                                                           
                        confirmBtnText={props.t("OK")}
                        cancelBtnText={props.t("Cancel")}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => {                                     
                            setIsEditing(false);
                            setState(props.content)    
                            if (props.module === Modules.COMMENT && !props.isEmpty) {
                                props.handleEditClick(true)
                            }                                                                      
                        }}
                        onCancel={() => {                                                 
                            setIsAlert(false)
                    }} />
                    )}
                    <ReactQuill
                        inputRef={el => setEditor(el)}
                        onBlur={handleQuillBlur}
                        theme="snow"
                        value={state}
                        onChange={handleChange}
                        placeholder={props.placeholder ? props.t(props.placeholder) : props.t("Add description")}
                        
                        modules={
                            {
                                toolbar: { 
                                    container: `${props?.toolbarId ? '#' + props.toolbarId : '#toolbar'}`,
                                    ...modules?.toolbar
                                },
                                history: modules.history
                            }
                        }
                        formats={formats}
                        className={isEditing ? 'quill-textarea'  : ''}
                    />
                    <div className={props.module === Modules.COMMENT ? "list-inline d-flex my-2 align-items-center comment_actions" : "d-flex justify-content-end"}>
                        <div className="gap-2 mt-2">
                            <Button id="save-button" color="light" className="btn-border me-2" onClick={() => {
                                if (props.content !== state) {
                                    props.emitItem(state);
                                }
                                setIsEditing(false);
                                 if (props.module === Modules.COMMENT && !props.isEmpty) {
                                     props.handleEditClick(true)
                                 }
                            }}>
                            {!isCommentModule ? (<i className="ri-check-line align-bottom"></i>) : props.t('Save')}
                            </Button>
                            <Button id="cancel-button" color="light" className="btn-border" onClick={() => {
                                    if (props.content !== state) {
                                        setState(props.content);
                                    }
                                    setIsEditing(false);
                                    if (props.module === Modules.COMMENT && !props.isEmpty) {
                                        props.handleEditClick(true)
                                    }
                                }} >
                                 {!isCommentModule ? (<i className="ri-close-line align-bottom"></i>) : props.t('Cancel')}
                            </Button>
                        </div>
                    </div>
                </div> :
                <ReactQuill
                    theme="snow"
                    readOnly={props?.disabled}
                    disabled={props?.disabled}
                    value={state}
                    className={props?.module && !props?.content ? 'empty_visible_comment' : (props?.module && props?.content ? 'visible_comment' : '')}
                    onChange={handleChange}
                    onFocus={(e) => handleFocus(e)}
                    placeholder={props?.placeholder ? props.t(props.placeholder) : props.t("Add description")}
                    modules={{ toolbar: false }}
                />
            }
        </>
    );
};

export default withTranslation() (TextEditor);